/* import __COLOCATED_TEMPLATE__ from './lsg-text-area.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import clsx from 'clsx';

/**
 * Possible sizes for the textAreaSize param.  How big is the min-height of the textarea.
 *
 * @type {Object}
 */
const LSG_TEXT_AREA_SIZES = {
  NORMAL: 'normal',
  LARGE: 'large'
};

export default Component.extend({
  /**
   * @inheritDoc
   */
  classNames: ['LSG-c-text-area'],
  classNameBindings: [
    'isAllowScroll:LSG-c-text-area--allow-scroll',
    'isDisabled:LSG-c-text-area--disabled',
    'isRoundedBorder:LSG-c-text-area--rounded-border',
    'isHighlightOnFocus::LSG-c-text-area--no-highlight-on-focus',
    '_isSizeLarge:LSG-c-text-area--textarea-large'
  ],

  maxLength: undefined,

  /**
   * The name of this input
   *
   * @param {String}
   */
  name: '',

  /**
   * Value of the input.  Intended for the parent to bind a variable to this to get input from the
   * text area.
   *
   * @param {String}
   */
  value: '',

  /**
   * Set to true to allow scrolling in the text area.
   *
   * @param {Boolean=}
   */
  isAllowScroll: true,

  /**
   * Place holder for text will remove when user starts typing
   *
   * @param {String=}
   */
  placeholder: '',

  /**
   * Optional label for text area.
   *
   * @param {String=}
   */
  title: '',

  /**
   * The inputId or we'll generate a unique one.
   *
   * @param {String=}   Optional
   */
  inputId: computed(function() {
    return 'lsg-text-area' + this.get('elementId');
  }),

  /**
   * @type {Boolean}    Optional.     Set to true when we're disabling this text are
   */
  isDisabled: false,

  /**
   * @param {Boolean=}   Optional.    Set to true if you want a rounded solid border
   */
  isRoundedBorder: false,

  /**
   * @param {Boolean=}    Optional.    Set to true if you do NOT want the bottom border to highlight on focus.
   */
  isHighlightOnFocus: true,

  /**
   * @param {String=}     Optional.    of type LSG_TEXT_AREA_SIZES.*   Default min size of text area
   */
  textAreaSize: LSG_TEXT_AREA_SIZES.NORMAL,

  /**
   * @type {Boolean}      True when the textAreaSize has focus
   */
  _hasFocus: false,

  /**
   * @type {Boolean}      True when the textAreaSize is large
   */
  _isSizeLarge: computed('textAreaSize', function() {
    return this.get('textAreaSize') === LSG_TEXT_AREA_SIZES.LARGE;
  }),

  /**
   * @type {String}       Unique id for the label.
   */
  _labelId: computed('', function() {
    return `${this.get('inputId')}--label`;
  }),

  _labelClassNames: computed('_hasFocus', 'value', function() {
    return clsx(Boolean(this._hasFocus || this.value) && 'active');
  }),

  /**
   * @inheritDoc
   */
  focusIn() {
    this.set('_hasFocus', true);
  },

  /**
   * @inheritDoc
   */
  focusOut() {
    this.set('_hasFocus', false);
  },
});
